import { redeemRewardSkeletonStyle as styles } from "./redeemRewardSkeleton.tailwind";
const RedeemRewardSkeleton = ({ count = 3, earnedReward = false }) => {
  return (
    <div className={styles.outerContainer}>
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className={`${earnedReward ? "min-h-[150px]" : "min-h-[200px]"} ${styles.skeleton}`} />
      ))}
    </div>
  );
};

export default RedeemRewardSkeleton;
